import { SplitFactory } from '@splitsoftware/splitio';
import md5 from 'md5';
import appConfig from 'config/app/app-config';

function FeatureFlagService() {
  let _userId;
  let _sdkReady = false;
  const config = {
    core: {
      authorizationKey: appConfig.featureFlag
        ? appConfig.featureFlag.key
        : 'localhost',
      key: 'REACTJS'
    }
  };
  const SplitFactoryInstance = SplitFactory(config);
  const SplitFactoryClient = SplitFactoryInstance.client();
  const onSdkReadyObservers = [];
  const attributes = {};

  SplitFactoryClient.on(SplitFactoryClient.SDK_READY, () => {
    // logger.log('Feature Flag sdk ready');
    onSdkReadyObservers.forEach((observer) => {
      if (typeof observer === 'function') {
        observer();
      }
    });
    _sdkReady = true;
  });

  /*
  SplitFactoryClient.on(SplitFactoryClient.SDK_UPDATE, () => {
    logger.log('Feature Flag sdk update');
  });
  */

  const _onSdkReady = (callback) => {
    onSdkReadyObservers.push(callback);
    if (_sdkReady) {
      callback();
    }
  };

  const _init = (userId) => {
    _userId = userId;
  };

  const _getFlag = (name, defaultValue) => {
    // logger.log(`_getFalg : [${name}]`, _sdkReady);
    if (_sdkReady && _userId) {
      attributes.user_id = md5(_userId).toUpperCase();
      // logger.log('Returning flag on ready: ', attributes);
      return SplitFactoryClient.getTreatment(name, attributes) === 'on';
    }
    // logger.log(`Return default [${defaultValue}]`);
    return defaultValue;
  };

  return {
    onSdkReady: _onSdkReady,
    // init must be call to initialize the feature flag service
    init: _init,
    getFlag: _getFlag
  };
}

const featureFlagServiceInstance = new FeatureFlagService();

export default featureFlagServiceInstance;
